import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "location",
  "use": "location-usage",
  "viewBox": "0 0 34 48",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 48\" id=\"location\"><path clip-rule=\"evenodd\" d=\"M17 24a7.5 7.5 0 100-15 7.5 7.5 0 000 15z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /><path clip-rule=\"evenodd\" d=\"M17 1.5c8.284 0 15 6.716 15 15 0 6.814-10.148 23.9-13.75 29.33a1.5 1.5 0 01-2.5 0C12.148 40.4 2 23.314 2 16.5c0-8.284 6.716-15 15-15z\" stroke=\"currentColor\" stroke-width=\"3\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/location.svg
// module id = pF+L
// module chunks = 38 43